import AddIcon from 'assets/icons/add';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import plusIcon from 'assets/images/icons/plus.svg';

const HeaderCreateButton = ({ onCreateHandler, activeCreateButton = false }) => {
	const theme = useTheme();

	return (
		<Button
			type="primary"
			onClick={onCreateHandler}
			disabled={activeCreateButton}
			sx={{
				gap: '4px',
				color: 'white',
				fontWeight: 450,
				display: 'flex',
				boxShadow: 'none',
				lineHeight: '18px',
				padding: '5px 10px',
				border: `1px solid`,
				alignItems: 'center',
				transition: 'all 0.3s',
				// backgroundColor: theme.palette.lynTheme.success,
				backgroundColor: '#6FC43D',
				borderColor: activeCreateButton ? 'gray' : '#F1F9EC',

				'&:hover': {
					backgroundColor: activeCreateButton ? 'gray' : '#6FC43D',

					transform: 'scale(0.9)',
				},
			}}
		>
			{/* <img src={plusIcon} alt="add" width="12" height="12" style={{ marginRight: '8px' }} /> */}
			<AddIcon width="18px" height="18px" color="#fff" />
			Create
		</Button>
	);
};

export default HeaderCreateButton;
